import Transition from '../style/TransitionFunction'



export default {
  name: 'CoreCollapseTransition',
  functional: true,
  render: function (createElement, context) {
    const data = {
      on: new Transition()
    }

    return createElement('transition', data, context.children)
  }
}



// WEBPACK FOOTER //
// ./src/components/CoreCollapseTransition.js